// Sync <html class="dark"> with system preference when theme is "system".
// Reads the cookie set by the theme controller; defaults to "system".

function currentTheme() {
  const m = document.cookie.match(/(?:^|; )dora_theme=([^;]+)/);
  const v = m ? decodeURIComponent(m[1]) : "system";
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

export function startThemeWatcher() {
  const apply = () => {
    if (currentTheme() !== "system") return;
    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    document.documentElement.classList.toggle("dark", isDark);
  };
  apply();
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", apply);
}
